<template>
  <transition name="fade">
    <div>
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  },

  computed: {

  },

  methods: {
    
  },

 created() {

 }
}
</script>

<style>
  html { overflow-y: auto }
  .pointer {cursor: pointer;}
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>


